import React from 'react';
import { block } from '../utils/cn';
import './StoreBadge.css';
import { Lang } from '../index';
const b = block('store-badge');
export function StoreBadge({ platform, lang = Lang.En, className, onClick, url, alt, }) {
    if (!url) {
        return React.createElement("img", { className: b({ platform, lang }, className), onClick: onClick, alt: alt });
    }
    return (React.createElement("a", { className: b(null, className), onClick: onClick, href: url, target: "_blank", rel: "noopener noreferrer" },
        React.createElement("img", { className: b('image', { platform, lang }), alt: alt })));
}
